import { useMemo } from 'react';
import { SidebarItem } from '@backstage/core-components';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';
import { useBackend } from '../useOrchestrator';
import { correlateByTicket } from './correlate';
import type { MyFailures, MyPullRequests } from './types';

/**
 * Sidebar entry of "Mon travail" with the number of things to handle (failures and PRs
 * needing action). Envs about to expire are left out: listing them inspects AWS, too heavy
 * for every page of the portal.
 */
export function MyWorkSidebarItem() {
  const failures = useBackend<MyFailures>(
    'platform-orchestrator',
    '/me/failures',
    { refreshMs: 120_000 },
  );
  const prs = useBackend<MyPullRequests>(
    'platform-orchestrator',
    '/me/pull-requests',
    { refreshMs: 120_000 },
  );
  const count = useMemo(
    () =>
      correlateByTicket({
        issues: [],
        prs: prs.value?.mine ?? [],
        envs: [],
        pipelines: [],
        failures: failures.value,
        me: { userRef: '' },
        now: Date.now(),
      }).alerts.length,
    [prs.value, failures.value],
  );
  return (
    <SidebarItem
      icon={WorkOutlineIcon}
      to="/my-work"
      text={count > 0 ? `Mon travail (${count})` : 'Mon travail'}
      hasNotifications={count > 0}
    />
  );
}
